import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalBloodAnalysis } from '../../interfaces/blood-local-analysis';
import { BloodPost } from '../../interfaces/blood-post.inteface';

@Injectable({
  providedIn: 'root',
})
export class BloodAddService {
  public localAnalyses: LocalBloodAnalysis[] = [];

  constructor(private http: HttpClient) {}

  public create(data: BloodPost): Observable<{ id: string }> {
    return this.http.post<{ id: string }>('/api/blood/results', data);
  }

  public update(resultId: string, data: BloodPost): Observable<{ id: string }> {
    return this.http.put<{ id: string }>(
      `/api/blood/results/${resultId}`,
      data
    );
  }

  public addLocal(data: LocalBloodAnalysis) {
    this.localAnalyses.push(data);
  }

  public updateLocal(data: LocalBloodAnalysis) {
    const index = this.localAnalyses.findIndex(
      (localAnalysis) => localAnalysis.analysisId === data.analysisId
    );

    this.localAnalyses[index] = data;
  }

  public removeLocal(data: LocalBloodAnalysis) {
    this.localAnalyses = this.localAnalyses.filter(
      (localAnalysis) => localAnalysis.analysisId !== data.analysisId
    );
  }
}
